import axios, { AxiosResponse } from 'axios'
import { env } from '@js/utils/env'
import gql from '@js/api/utils/gql'
import getStoreName from '@js/api/utils/getStoreName'
import getBearerToken from '@js/api/utils/getBearerToken'

interface TriggerRlpCompletedJobResponse {
  data: {
    wceiTriggerRlpCompletedJob: {
      message: string
    }
  }
  errors?: [{ message: string }]
}

export const TriggerRlpCompletedJobMutation = gql`
  mutation($registrationId: Int!) {
    wceiTriggerRlpCompletedJob(
      input: {
        registration_id: $registrationId
      }
    ) {
      message
    }
  }
`

/**
 * @throws {string}
 *
 * Will throw one error message; Magento only returns one at a time.
 */
export const triggerRlpCompletedJob = async (
  payload: {
    registrationId: number,
  }
): Promise<string | null> => {
  const bearerToken = getBearerToken()

  const { data }: AxiosResponse<TriggerRlpCompletedJobResponse> = await axios({
    method: 'POST',
    url: env.magento.GRAPHQL_URL,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${bearerToken}`,
      Store: getStoreName(),
    },
    data: {
      query: TriggerRlpCompletedJobMutation,
      variables: {
        registrationId: payload.registrationId,
      },
    },
  })

  if (data.errors) {
    throw data.errors[0].message
  }

  if (data.data.wceiTriggerRlpCompletedJob) {
    return data.data.wceiTriggerRlpCompletedJob.message
  }

  return null
}
